import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d71e7f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operate_wrap" }
const _hoisted_2 = { class: "mod_search_form" }
const _hoisted_3 = { class: "dropdown_menu_top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown_menu_title" }, "通知方式", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown_menu_title" }, "通知设置", -1))
const _hoisted_6 = { class: "dropdown_menu_send" }
const _hoisted_7 = {
  key: 1,
  class: "dropdown_menu_footer"
}
const _hoisted_8 = { class: "operate_wrap_choose" }
const _hoisted_9 = { class: "operate_btn_box" }
const _hoisted_10 = { class: "action_desc" }
const _hoisted_11 = { class: "ltwm_item_btn" }
const _hoisted_12 = {
  key: 0,
  class: "mod_pagin"
}

import { Moment } from 'moment';
import { computed, reactive, ref, watch, getCurrentInstance } from 'vue';
import {
  DatePicker,
  Input,
  Select,
  Table,
  Radio,
  Dropdown,
  Menu,
  Modal,
  Tooltip,
  Checkbox,
  message,
  Pagination,
  Popover,
  Image,
  notification,
} from 'ant-design-vue';
import { SearchOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
import { TableState } from 'ant-design-vue/es/table/interface';
import { useDebounce } from '@/hooks/useDebounce';
import { useRoute } from 'vue-router';
import CDelModal from '@/components/CDelModal.vue';
import ReviewModal from './ReviewModal.vue';
import http from '@/api';
import { getExamineStatus, getToken } from '@/plugins/cookie';
import { dateFormats } from '@/utils/format/date';
import { FormObj } from './type';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';

interface Options {
  label: string;
  value: number | '';
}
interface NoticeType {
  messageSend: boolean;
  mailSend: boolean;
  wxSend: boolean;
  noSend: boolean;
  sendType: number;
}
type Paginations = TableState['pagination'];

interface Imodal {
  title: string;
  visible: boolean;
  loading: boolean;
}
interface otherRevieType {
  password: string;
  exa: number;
  reg: number;
  other_link: string;
}
/***
 * @password -密码
 * @exa -观众审核
 * @reg -观众注册权限
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewList',
  props: {
    activeKey: null,
    formArr: null
  },
  setup(__props: any) {

const props = __props as { activeKey: number; formArr: FormObj[] };

const aDatePicker = DatePicker;
const aInputSearch = Input.Search;
const aSelect = Select;
const aTable = Table;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aDropdown = Dropdown;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const aMenuDivider = Menu.Divider;
const aModal = Modal;
const aTooltip = Tooltip;
const aCheckbox = Checkbox;
const aPagination = Pagination;
const aPopover = Popover;
const aImage = Image;

const route = useRoute();
const studioId = computed(() => route.params.studioId);
const reviewStatus = ref<number>();
const showLoading = ref(false);

const statusOpeion: Options[] = [
  { label: '待审核', value: 0 },
  { label: '已通过', value: 1 },
  { label: '未通过', value: 2 },
  { label: '已驳回', value: 3 },
  { label: '全部', value: 4 },
];

const liveDate = ref<Moment>();
const keywords = ref('');
const reviewRadio = ref(0);
const visible = ref(false);

const notice = ref<NoticeType>({
  messageSend: false,
  mailSend: false,
  wxSend: false,
  noSend: false,
  sendType: 0,
});
const isDisable = reactive({
  email_send: 0,
  mobile_send: 0,
  wx_send: 0,
});

const onChangeSend = () => {
  const isOneNotDis = computed(() => isDisable.email_send || isDisable.mobile_send || isDisable.wx_send);
  const isOneClick = computed(() => notice.value.messageSend || notice.value.mailSend || notice.value.wxSend);
  const isShowMessage = computed(() => !notice.value.sendType && isOneNotDis && isOneClick);
  return isShowMessage.value;
};

const showMeaage = useDebounce((key: number) => {
  if (key === 3 && notice.value.noSend) {
    notice.value.messageSend = notice.value.mailSend = notice.value.wxSend = false;
  } else {
    notice.value.noSend = false;
  }
  const data = {
    studio_id: studioId.value,
    sms_notification: !key ? Number(notice.value.messageSend) : undefined,
    email_notification: key === 1 ? Number(notice.value.mailSend) : undefined,
    we_chat_notification: key === 2 ? Number(notice.value.wxSend) : undefined,
    not_send: key === 3 ? Number(notice.value.noSend) : undefined,
  };
  http.live
    .sendMessage(data)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
});

const onChangeType = useDebounce(() => {
  http.live
    .setSendType({ studio_id: studioId.value, send_type: notice.value.sendType })
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
});

const onManualSend = () => {
  http.live
    .setManualSend({ studio_id: studioId.value })
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

const formatTxt = (keyword: number): string => {
  switch (keyword) {
    case 1:
      return '已通过';
    case 2:
      return '未通过';
    case 3:
      return '已驳回';
    default:
      return '待审核';
  }
};
const formatColorCode = (keyword: number): string => {
  switch (keyword) {
    case 1:
      return 'success';
    case 2:
      return 'error';
    case 3:
      return 'reject';
    default:
      return 'default';
  }
};



const sortedInfo = ref();
// const columns = computed(() => {
//   const sorted = sortedInfo.value || {};
//   return [
//     {
//       title: 'ID/名称',
//       dataIndex: 'id',
//       key: 'id',
//       align: 'center',
//       ellipsis: true,
//       slots: { customRender: 'key' },
//     },
//     {
//       title: '用户IP',
//       dataIndex: 'ip',
//       key: 'ip',
//       align: 'center',
//     },
//     {
//       title: '表单账号',
//       dataIndex: 'account',
//       key: 'account',
//       align: 'center',
//     },
//     {
//       title: '表单昵称',
//       dataIndex: 'account_nickname',
//       key: 'account_nickname',
//       align: 'center',
//     },
//     {
//       title: '用户昵称',
//       dataIndex: 'nickname',
//       key: 'nickname',
//       align: 'center',
//     },
//     {
//       title: '所在地区',
//       dataIndex: 'address',
//       key: 'address',
//       align: 'center',
//     },
//     {
//       title: '注册时间',
//       dataIndex: 'created_at',
//       key: 'created_at',
//       sorter: (a: any, b: any) => (a.created_at > b.created_at ? 1 : -1),
//       sortOrder: sorted.columnKey === 'created_at' && sorted.order,
//       ellipsis: true,
//       align: 'center',
//     },
//     {
//       title: '审核操作',
//       key: 'operation',
//       fixed: 'right',
//       width: 200,
//       sorter: (a: any, b: any) => a.user_examine_status - b.user_examine_status,
//       sortOrder: sorted.columnKey === 'operation' && sorted.order,
//       slots: { customRender: 'action' },
//       align: 'center',
//     },
//   ];
// });
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});
const viewList = ref<[]>([]);
const columns = ref([]);
// 获取表单数据
const getFormList = () => {
  showLoading.value = true;
  const data = {
    studio_id: studioId.value,
    status: 2,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    keywords: keywords.value,
    time: dateFormats(liveDate.value),
    user_examine_status: reviewStatus.value !== 4 ? reviewStatus.value : undefined, //审核状态 0待审核 1通过 2未通过 3驳回 (仅限报名审核表单数据)
  };
  http.live
    .getViewListForm({ params: data })
    .then((res) => {
      showLoading.value = false;
      viewList.value = res.data.data?.data?.data || viewList.value;
      const resHead = JSON.parse(res.data.data.head);
      const resHeadTitle = ref('');
      props.formArr.forEach((e) => {
        if (e.select2 === '8') resHeadTitle.value = e.title;
      });
      let arr: any = [];
      resHead.forEach((item: any) => {
        const index = item.value.indexOf('_');
        const type = item.value.slice(0, index);
        if (index && type === 'image') {
          arr.push({
            title: item.name,
            dataIndex: item.value,
            align: 'center',
            slots: { customRender: 'image' },
          });
        } else if (item.value !== 'created_at') {
          if (item.name != resHeadTitle.value) {
            arr.push({
              title: item.name,
              dataIndex: item.value,
              align: 'center',
              ellipsis: true,
            });
          }
        } else {
          arr.push({
            title: item.name,
            dataIndex: item.value,
            sorter: (a: any, b: any) => (a.created_at > b.created_at ? 1 : -1),
            align: 'center',
          });
        }
      });
      arr.push({
        title: '审核操作',
        dataIndex: 'operation',
        slots: { customRender: 'action' },
        sorter: (a: any, b: any) => a.user_examine_status - b.user_examine_status,
        fixed: 'right',
        width: 180,
        align: 'center',
      });
      columns.value = arr;
      notice.value.mailSend = Boolean(res.data.data.email_notification);
      notice.value.messageSend = Boolean(res.data.data.sms_notification);
      notice.value.wxSend = Boolean(res.data.data.we_chat_notification);
      notice.value.noSend = Boolean(res.data.data.not_send);
      notice.value.sendType = res.data.data.send_type;
      reviewRadio.value = res.data.data.exemption_examine || reviewRadio.value; //免审核开关
      isDisable.email_send = res.data.data.email_send || isDisable.email_send;
      isDisable.mobile_send = res.data.data.mobile_send || isDisable.mobile_send;
      isDisable.wx_send = res.data.data.wx_send || isDisable.wx_send;
      if (res.data.data.data) {
        pageConfig.current = res.data.data.data.current_page;
        pageConfig.totalSize = res.data.data.data.total;
      }
      if (!res.data.data.data) {
        message.info(res.data.message);
      }
    })
    .catch((err) => console.error(err.data.error));
};
getFormList();

watch(
  () => props.activeKey,
  () => {
    if (props.activeKey === 2) getFormList();
  }
);

const handleChange = (pagination: Paginations, _: unknown, sorter: any) => {
  sortedInfo.value = sorter;
};

const selectedRowKeys = ref<string[]>([]);
const onSelectChange = (selectedRowKey: string[]) => {
  console.log('selectedRowKeys changed: ', selectedRowKey);
  selectedRowKeys.value = selectedRowKey;
};

// 审核操作
const setExamineState = (type: number, record?: number) => {
  message.destroy();
  //  type 1通过 2未通过 3驳回 4删除
  const data = {
    studio_id: studioId.value,
    ids: record ? record : selectedRowKeys.value.join(','),
    user_examine_status: type,
  };
  http.live
    .auditOperation(data)
    .then((res) => {
      message.success(res.data.message);
      getFormList();
      selectedRowKeys.value = [];
      delModal.visible = false;
      delModals.visible = false;
    })
    .catch((err) => message.error(err.data.error));
};

const rejectReviewModal = reactive<Imodal>({
  title: '驳回',
  visible: false,
  loading: false,
});
const openRejectModal = useDebounce(async () => {
  rejectReviewModal.visible = !rejectReviewModal.visible;
});

const delModal = reactive<Imodal>({
  title: '删除',
  visible: false,
  loading: false,
});
const recordId = ref<number>();
const openDelModal = (id?: number) => {
  id ? (recordId.value = id) : '';
  delModal.visible = !delModal.visible;
};

const delModals = reactive<Imodal>({
  title: '删除',
  visible: false,
  loading: false,
});
const openDelModals = () => {
  delModals.visible = !delModals.visible;
};
// 更改报名审核免审核状态
const updataMove = () => {
  const data = { studio_id: studioId.value, exemption_examine: reviewRadio.value };
  http.live
    .updataDisExamine(data)
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

class otherRevieClass {
  other_link: string;
  password: string;
  exa: boolean;
  reg: boolean;
  constructor(data: otherRevieType) {
    this.password = data.password;
    this.exa = data.exa ? true : false;
    this.reg = data.reg ? true : false;
    this.other_link = data.other_link;
  }
}
const otherReviewFrom = ref<otherRevieClass>({
  other_link: '',
  password: '',
  exa: false,
  reg: false,
});

// 获取第三方审核配置
const getThirdParty = () => {
  const data = { studio_id: studioId.value };
  http.live
    .getThirdParty({ params: data })
    .then((res) => {
      otherReviewFrom.value = new otherRevieClass(res.data.data);
    })
    .catch((err) => {
      console.error(err.data.error);
    });
};
getThirdParty();

const setThirdParty = () => {
  otherReviewModal.loading = true;
  const data = {
    studio_id: studioId.value,
    password: otherReviewFrom.value.password,
    reg: otherReviewFrom.value.reg ? 1 : 0,
    exa: otherReviewFrom.value.exa ? 1 : 0,
  };
  http.live
    .setThirdParty(data)
    .then((res) => {
      message.success(res.data.message);
      otherReviewModal.visible = false;
      otherReviewModal.loading = false;
    })
    .catch((err) => message.error(err.data.error))
    .finally(() => (otherReviewModal.loading = false));
};
const otherReviewModal = reactive<Imodal>({
  title: '审核助手',
  visible: false,
  loading: false,
});
const openReviewModal = useDebounce(async () => {
  otherReviewModal.visible = !otherReviewModal.visible;
});
const setSubAuto = useDebounce(() => {
  setThirdParty();
});

const isExamine = getExamineStatus(); // 是否是第三方审核登录
const { proxy }: any = getCurrentInstance();
const corn = ref(1);
const messageTip = ref();
const excel = useDebounce((state: string) => {
  if (state) parseInt(state);
  const data = {
    studio_id: studioId.value,
    type: 38,
    examine_status: state,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(aDropdown), {
          trigger: ['click'],
          visible: visible.value,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event))
        }, {
          overlay: _withCtx(() => [
            _createVNode(_unref(aMenu), { class: "dropdown_menu_s" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item_s"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aCheckbox), {
                        checked: notice.value.noSend,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((notice.value.noSend) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(showMeaage)(3)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("不发送")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item_s"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aCheckbox), {
                        checked: notice.value.messageSend,
                        "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((notice.value.messageSend) = $event)),
                        disabled: !isDisable.mobile_send,
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(showMeaage)(0)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("短信通知")
                        ]),
                        _: 1
                      }, 8, ["checked", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item_s"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aCheckbox), {
                        checked: notice.value.mailSend,
                        "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((notice.value.mailSend) = $event)),
                        disabled: !isDisable.email_send,
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(showMeaage)(1)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("邮件通知")
                        ]),
                        _: 1
                      }, 8, ["checked", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item_s"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aCheckbox), {
                        checked: notice.value.wxSend,
                        "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((notice.value.wxSend) = $event)),
                        disabled: !isDisable.wx_send,
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(showMeaage)(2)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("微信通知")
                        ]),
                        _: 1
                      }, 8, ["checked", "disabled"])
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(aRadioGroup), {
                      name: "radioGroup",
                      value: notice.value.sendType,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((notice.value.sendType) = $event)),
                      onChange: _unref(onChangeType)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aRadio), {
                          value: 0,
                          class: "dropdown_menu_radio"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("自动发送")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(aRadio), {
                          value: 1,
                          class: "dropdown_menu_radio"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("手动发送")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "onChange"])
                  ])
                ]),
                (notice.value.sendType)
                  ? (_openBlock(), _createBlock(_unref(aMenuDivider), { key: 0 }))
                  : _createCommentVNode("", true),
                (notice.value.sendType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        class: "dropdown_menu_btn",
                        onClick: onManualSend
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发送")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              class: "mod_search_form_func",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("审核通知")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"]),
        (!_unref(isExamine))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "mod_search_form_func",
              onClick: _unref(openReviewModal)
            }, {
              default: _withCtx(() => [
                _createTextVNode("审核助手")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(aDatePicker), {
          class: "mod_search_form_func mod_range_picker",
          style: {"min-width":"120px","width":"120px"},
          value: liveDate.value,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((liveDate).value = $event)),
          placeholder: "注册时间",
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          onOk: getFormList
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search",
          value: keywords.value,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((keywords).value = $event)),
          placeholder: "请输入关键字",
          onSearch: getFormList
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(aSelect), {
          class: "list_file_class mod_select",
          placeholder: "审核状态",
          value: reviewStatus.value,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((reviewStatus).value = $event)),
          options: statusOpeion,
          onChange: getFormList
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createTextVNode(" 免审核： "),
          _createVNode(_unref(aRadioGroup), {
            name: "radioGroup",
            value: reviewRadio.value,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((reviewRadio).value = $event)),
            onChange: updataMove
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(aRadio), { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("开启")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(aDropdown), {
            disabled: selectedRowKeys.value.length === 0
          }, {
            overlay: _withCtx(() => [
              _createVNode(_unref(aMenu), { class: "dropdown_menu" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aMenuItem), {
                    key: "0",
                    class: "dropdown_item",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (setExamineState(1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        "icon-class": "review_success",
                        class: "dropdown_item_icon"
                      }),
                      _createTextVNode(" 批量通过 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (setExamineState(2)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        "icon-class": "review_error",
                        class: "dropdown_item_icon"
                      }),
                      _createTextVNode(" 批量拒绝 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (setExamineState(3)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        "icon-class": "review_reject",
                        class: "dropdown_item_icon"
                      }),
                      _createTextVNode(" 批量驳回 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "operate_btn first"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "operate_btn_title",
                    "icon-class": "review_set_btn"
                  }),
                  _createVNode(_unref(CaretDownOutlined))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(aDropdown), null, {
            overlay: _withCtx(() => [
              _createVNode(_unref(aMenu), { class: "dropdown_menu" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aMenuItem), {
                    key: "0",
                    class: "dropdown_item",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(excel)('')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 全部 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(excel)('0')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 待审核 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(excel)('1')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 已通过 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(excel)('2')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 未通过 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aMenuItem), {
                    key: "1",
                    class: "dropdown_item",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_unref(excel)('3')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 已驳回 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "operate_btn first"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "operate_btn_title",
                    "icon-class": "review_set_export"
                  }),
                  _createVNode(_unref(CaretDownOutlined))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "operate_btn",
            disabled: selectedRowKeys.value.length === 0,
            onClick: openDelModals
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_icon, { "icon-class": "review_set_del" })
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(aTable), {
        class: "ant-table-striped table_image",
        "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
        columns: columns.value,
        "data-source": viewList.value,
        onChange: handleChange,
        pagination: false,
        rowClassName: (record) => 'row_bg_' + formatColorCode(record.user_examine_status),
        "row-key": "id",
        size: "small",
        loading: showLoading.value
      }, {
        image: _withCtx(({ text }) => [
          text
            ? (_openBlock(), _createBlock(_unref(aImage), {
                key: 0,
                src: text
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        key: _withCtx(({ record }) => [
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(record.id), 1)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(record.id), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        action: _withCtx(({ record }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["action", 'review-' + formatColorCode(record.user_examine_status)])
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(formatTxt(record.user_examine_status)), 1),
            _withDirectives(_createVNode(_component_svg_icon, { "icon-class": "review_success" }, null, 512), [
              [_vShow, record.user_examine_status === 1]
            ]),
            _withDirectives(_createVNode(_component_svg_icon, { "icon-class": "review_error" }, null, 512), [
              [_vShow, record.user_examine_status === 2]
            ]),
            _withDirectives(_createVNode(_component_svg_icon, { "icon-class": "review_reject" }, null, 512), [
              [_vShow, record.user_examine_status === 3]
            ]),
            _withDirectives(_createVNode(_component_svg_icon, { "icon-class": "review_default" }, null, 512), [
              [_vShow, record.user_examine_status === 0]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(aDropdown), {
                trigger: ['click'],
                overlayClassName: "dropdown_body"
              }, {
                overlay: _withCtx(() => [
                  _createVNode(_unref(aMenu), { class: "dropdown_menu" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aMenuItem), {
                        key: "0",
                        class: "dropdown_item",
                        onClick: ($event: any) => (setExamineState(1, record.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            "icon-class": "review_success",
                            class: "dropdown_item_icon"
                          }),
                          _createTextVNode(" 通过 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_unref(aMenuItem), {
                        key: "1",
                        class: "dropdown_item",
                        onClick: ($event: any) => (setExamineState(2, record.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            "icon-class": "review_error",
                            class: "dropdown_item_icon"
                          }),
                          _createTextVNode(" 拒绝 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_unref(aMenuItem), {
                        key: "1",
                        class: "dropdown_item",
                        onClick: ($event: any) => (setExamineState(3, record.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            "icon-class": "review_reject",
                            class: "dropdown_item_icon"
                          }),
                          _createTextVNode(" 驳回 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_unref(aMenuItem), {
                        key: "1",
                        class: "dropdown_item",
                        onClick: ($event: any) => (openDelModal(record.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            "icon-class": "review_action_delete",
                            class: "dropdown_item_icon"
                          }),
                          _createTextVNode("删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode(" 操作 ")
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "opera_btn",
                        onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createVNode(_component_svg_icon, { "icon-class": "review_action" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["row-selection", "columns", "data-source", "rowClassName", "loading"])
    ]),
    (viewList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_unref(aPagination), {
            "show-quick-jumper": "",
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[23] || (_cache[23] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[24] || (_cache[24] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-size-changer": "",
            onChange: getFormList,
            onShowSizeChange: getFormList
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(aModal), {
      visible: otherReviewModal.visible,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((otherReviewModal.visible) = $event)),
      title: otherReviewModal.title,
      width: 560,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (_unref(openReviewModal)()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          loading: otherReviewModal.loading,
          onClick: _unref(setSubAuto)
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(ReviewModal, {
          modelValue: otherReviewFrom.value,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((otherReviewFrom).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_unref(aModal), {
      visible: rejectReviewModal.visible,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((rejectReviewModal.visible) = $event)),
      title: rejectReviewModal.title,
      width: 560,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: _cache[28] || (_cache[28] = ($event: any) => (_unref(openRejectModal)()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "mod_modal_btn mod_type_primary",
          loading: rejectReviewModal.loading,
          onClick: _unref(openRejectModal)
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      close: openDelModal,
      ok: () => setExamineState(4, recordId.value)
    }, null, 8, ["visible", "ok"]),
    _createVNode(CDelModal, {
      visible: delModals.visible,
      centered: "",
      close: openDelModals,
      ok: () => setExamineState(4)
    }, null, 8, ["visible", "ok"])
  ]))
}
}

})